export default __webpack_public_path__ + "static/media/i082sk.d5d6d42a.webp";